import { RootState } from "@store/index";
import { createSelector } from "reselect";
import { TestSessionState } from "./testSessionSlice";

const testSessionState = (state: RootState) => state.testSession as TestSessionState;

export const selectCompletedTestIds = createSelector(
  [testSessionState],
  (state) => state.completedTestIds,
);

export const selectVfaAutoRestartCount = createSelector(
  [testSessionState],
  (state) => state.vfaAutoRestartCount,
);

export const selectVfaAutoRestartTestCategory = createSelector(
  [testSessionState],
  (state) => state.vfaAutoRestartTestCategory,
);
